import { ApiMethodType } from '@celito.clients/enums';
import { performRequest } from '@celito.clients/network';
import { AxiosResponse } from 'axios';

import {
  CancelExtensionRequestDto,
  CreateExtensionRequestDto,
  ExtensionRequest,
} from '../components/extension-request-dialog/extension-request-dialog.model';

const BASE_URL = '/extension-requests';

/**
 * Creates a new extension request
 * @param createDto The data for creating the extension request
 * @returns The created extension request
 */
export const createExtensionRequest = async (
  createDto: CreateExtensionRequestDto
): Promise<ExtensionRequest> => {
  const response: AxiosResponse<ExtensionRequest> =
    await performRequest<ExtensionRequest>(
      BASE_URL,
      ApiMethodType.POST,
      createDto
    );
  return response.data;
};

/**
 * Gets an extension request by ID
 * @param id The ID of the extension request to get
 * @returns The extension request
 */
export const getExtensionRequest = async (
  id: string
): Promise<ExtensionRequest> => {
  const response: AxiosResponse<ExtensionRequest> =
    await performRequest<ExtensionRequest>(
      `${BASE_URL}/${id}`,
      ApiMethodType.GET
    );
  return response.data;
};

/**
 * Cancels an extension request
 * @param id The ID of the extension request to cancel
 * @param cancelDto The data for cancelling the extension request
 * @returns The updated extension request
 */
export const cancelExtensionRequest = async (
  id: string,
  cancelDto: CancelExtensionRequestDto
): Promise<ExtensionRequest> => {
  const response: AxiosResponse<ExtensionRequest> =
    await performRequest<ExtensionRequest>(
      `${BASE_URL}/${id}/cancel`,
      ApiMethodType.POST,
      cancelDto
    );
  return response.data;
};

/**
 * Gets all extension requests for the current user
 * @returns A list of extension requests
 */
export const getExtensionRequests = async (): Promise<ExtensionRequest[]> => {
  const response: AxiosResponse<ExtensionRequest[]> = await performRequest<
    ExtensionRequest[]
  >(BASE_URL, ApiMethodType.GET);
  return response.data;
};
